import { IconFileText } from '@tabler/icons-react';
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from 'reactstrap';
import { PreQualficationStatusBadge } from './PreQualificationStatusBadge';
import { PreQualificationStatus } from '../enums/PreQualificationEnum';

interface Props {
  detail: {
    name: string;
    loan_requested: string;
    score: number | null;
    created_at: string;
    banking_offers: number;
    status: string;
  };
}

const PreQualificationDetailCard = ({ detail }: Props) => {
  const { banking_offers, created_at, loan_requested, name, score, status } =
    detail;
  return (
    <Card>
      <CardHeader className="bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <CardTitle className="d-flex align-items-center mb-0">
              <IconFileText size={20} className="text-primary me-2" />
              Resumen de Aplicación
            </CardTitle>
          </div>
          <PreQualficationStatusBadge
            status={status as PreQualificationStatus}
          />
        </div>
      </CardHeader>
      <CardBody>
        <Row className="text-capitalize">
          <Col md={3} className="mb-3">
            <small className="text-muted">Nombre</small>
            <div className="fw-bold fs-5">{name}</div>
          </Col>
          <Col md={3} className="mb-3">
            <small className="text-muted">Valor solicitado</small>
            <div className="fw-bold fs-5">
              {loan_requested.toLocaleString()}
            </div>
          </Col>
          <Col md={3} className="mb-3">
            <small className="text-muted">Score</small>
            <div className="fw-bold fs-5 text-primary">
              {score ? score : 'ND'}
            </div>
          </Col>
          <Col md={3} className="mb-3">
            <small className="text-muted">Fecha de creación</small>
            <div className="fw-bold">{created_at}</div>
          </Col>
          <Col md={3} className="mb-3">
            <small className="text-muted">Ofertas bancarias</small>
            <div className="fw-bold">{banking_offers} Disponibles</div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PreQualificationDetailCard;
